import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconResize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconResize"><Path d="M4.5 19.75H10V21.25H3V14.25H4.5V19.75Z" fill="currentColor"/><Path d="M17 17H7V7H17V17Z" fill="currentColor"/><Path d="M21 10H19.5V4.5H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconResize;
